import type { RouteObject } from "react-router";
import { MESSAGE_ROUTES } from "../constants/message-routes";

export const messageRoutes: RouteObject = {
	children: [
		{
			path: MESSAGE_ROUTES.LIST,
			lazy: async () => {
				const { default: MessagesPage } = await import("../pages/messages-page");
				return { Component: MessagesPage };
			},
		},
		{
			path: MESSAGE_ROUTES.DM,
			lazy: async () => {
				const { default: MessagesPage } = await import("../pages/messages-page");
				return { Component: MessagesPage };
			},
		},
	],
};
